import { Injectable } from '@angular/core';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';


const headers = new HttpHeaders({'Content-Type': 'application/json; charset=utf-8',
 'Access-Control-Allow-Origin': '*', 'Access-Control-Allow-Credentials': 'true',
  'Access-Control-Allow-Methods': 'GET, POST, PATCH, PUT, DELETE, OPTIONS'});

@Injectable({
  providedIn: 'root'
})


export class JaldeeVerifyLevelService {

  verificationUrl = '/superadmin/rest/mgmt/account/verification';
  verificationLogUrl = '/superadmin/rest/mgmt/account/verification/logs';
  corporateVerificationUrl = '/superadmin/rest/mgmt/corporate/verification';
  corporateVerificationLogUrl = '/superadmin/rest/mgmt/corporate/verification/logs';

  accountDetails: any;
  accountId: any;
  verifyLevel: any;
  corporateId: any;
  accountType: any;

  getCurrentLevelDetailsofAccount(id): Observable<any> {

    return this.http.get(this.verificationUrl + '/' +  id , { headers: headers});
  }
  getCurrentLevelDetailsofCorporate(id): Observable<any> {

    return this.http.get(this.corporateVerificationUrl + '/' +  id , { headers: headers});
  }

  constructor(private http: HttpClient) { }


setAccountDetails(id) {
  this.accountId = id;
}
getAccountDetails() {
  return this.accountId;
}
saveVerification(data): Observable<any> {
  return this.http.post(this.verificationUrl, data, { headers: headers});

}
updateVerification(data): Observable<any> {
  return this.http.put(this.verificationUrl, data, {headers: headers});
}
setVeriyLevel(level) {
  this.verifyLevel = level;
}
getVerifyLevel() {
  return this.verifyLevel;
}
getVerificationLogs(accountId): Observable<any> {
  return this.http.get(this.verificationLogUrl + '/' + accountId , {headers: headers});

}
getVerificationLogsofCorporate(corporateId): Observable<any> {
  return this.http.get(this.corporateVerificationLogUrl + '/' + corporateId , {headers: headers});
}
setTypeofAccount(data) {
  this.accountType = data;
}
getTypeofAccount() {
return this.accountType;
}
setCorporateId(id) {
  this.corporateId = id;
}
getCorporateId() {
 return this.corporateId;
}
saveVerificationForCorporate(data): Observable<any> {
return this.http.post(this.corporateVerificationUrl, data, {headers: headers});
}
getCorporateVerificationLogs(corporateId): Observable<any> {
  return this.http.get(this.corporateVerificationLogUrl + '/' + corporateId , {headers: headers});

}
updateVerificationForCorporate(data): Observable<any> {
  return this.http.put(this.corporateVerificationUrl, data, {headers: headers});
}

}